module.exports = __webpack_public_path__ + "static/nextdimension-logo-e1272fb6fd288282952a8164f7ad7051.jpg";